// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b2vN","col":"styles_col__zEpZM"};